module.exports = __webpack_public_path__ + "static/img/dDR4.2e8594ec.png";